// Pendiente de revisar
import { ItiBaseDto } from "@/iti-core-react/dtos/iti-base-dto";

export class ExperimentDto extends ItiBaseDto {
	public contextId: string;
	public name: string;
	public description: string;
	public ext_type: string;
	public repository_url: string;
	public repository_username: string;
	public repository_password: string;
	public createdAt: string;

	constructor(src?: any) {
		super(src);
		Object.assign(this, src);
	}
}
